import { render, staticRenderFns } from "./UserObservationCard.vue?vue&type=template&id=3b263308&scoped=true&"
import script from "./UserObservationCard.vue?vue&type=script&lang=js&"
export * from "./UserObservationCard.vue?vue&type=script&lang=js&"
import style0 from "./UserObservationCard.vue?vue&type=style&index=0&id=3b263308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b263308",
  null
  
)

export default component.exports